var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepositoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6087_89454)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85954 1.2111C4.17935 0.801748 4.66988 0.5625 5.18934 0.5625H11.1232C11.6426 0.5625 12.1332 0.801748 12.453 1.2111L15.6307 5.2787C15.708 5.37761 15.75 5.49951 15.75 5.625V7.59375H14.625V6.1875H1.6875V12.375C1.6875 12.6857 1.93934 12.9375 2.25 12.9375H7.59375V14.0625H2.25C1.31802 14.0625 0.5625 13.307 0.5625 12.375V5.625C0.5625 5.49951 0.604471 5.37761 0.681736 5.2787L3.85954 1.2111ZM5.18934 1.6875H7.59375V5.0625H2.27826L4.74607 1.9037C4.85269 1.76725 5.01618 1.6875 5.18934 1.6875ZM8.71875 1.6875V5.0625H14.0342L11.5664 1.9037C11.4598 1.76725 11.2963 1.6875 11.1232 1.6875H8.71875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 10.6875C15.2169 10.6875 15.4688 10.9393 15.4688 11.25C15.4688 11.5607 15.2169 11.8125 14.9062 11.8125H10.9688C10.6581 11.8125 10.4062 11.5607 10.4062 11.25C10.4062 10.9393 10.6581 10.6875 10.9688 10.6875H14.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 14.625C13.2188 14.9357 12.9669 15.1875 12.6562 15.1875H10.9688C10.6581 15.1875 10.4062 14.9357 10.4062 14.625C10.4062 14.3143 10.6581 14.0625 10.9688 14.0625H12.6562C12.9669 14.0625 13.2188 14.3143 13.2188 14.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 12.375C15.2169 12.375 15.4688 12.6268 15.4688 12.9375C15.4688 13.2482 15.2169 13.5 14.9062 13.5H10.9688C10.6581 13.5 10.4062 13.2482 10.4062 12.9375C10.4062 12.6268 10.6581 12.375 10.9688 12.375H14.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 8.4375C16.682 8.4375 17.4375 9.19302 17.4375 10.125V15.75C17.4375 16.682 16.682 17.4375 15.75 17.4375H10.125C9.19302 17.4375 8.4375 16.682 8.4375 15.75V10.125C8.4375 9.19302 9.19302 8.4375 10.125 8.4375H15.75ZM16.3125 10.125C16.3125 9.81433 16.0607 9.5625 15.75 9.5625H10.125C9.81433 9.5625 9.5625 9.81433 9.5625 10.125V15.75C9.5625 16.0607 9.81433 16.3125 10.125 16.3125H15.75C16.0607 16.3125 16.3125 16.0607 16.3125 15.75V10.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6087_89454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepositoryIcon);
export default __webpack_public_path__ + "static/media/repository_icon.0c2f5743e593883a1901ac4b0b7a57a0.svg";
export { ForwardRef as ReactComponent };